import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import initVersionCheck from "@/utils/versionCheck";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Initialize version check for automatic reload after deployments
initVersionCheck();
